'use client'

import { getColumns } from '../../../helpers/columns'
import styles from '../../Footer.module.scss'
import { FooterColumn } from './FooterColumn'
import { useLastBrowsedLocation } from '@/location/last-browsed-location/client'
import { useLocalisation } from '@/tools/i18n/client'

export const FooterColumns = () => {
  const { t, getLanguage } = useLocalisation()
  const { lastBrowsedLocation } = useLastBrowsedLocation()
  const columns = getColumns(t, getLanguage(), lastBrowsedLocation.countryCode) || []
  return (
    <section className={styles.grid}>
      {columns.map((column, i) => (
        <FooterColumn key={i} column={column} />
      ))}
    </section>
  )
}
